
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlane = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 87 55",
  width: 87,
  height: 55,
  style: {
    transform: "translate3d(0,0,0)",
    contentVisibility: "visible"
  }
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "plane_7ac63e5ec3093c84__b",
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "var(--theme-primary-grad,#BC32CE)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plane_7ac63e5ec3093c84__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h87v55H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#plane_7ac63e5ec3093c84__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#plane_7ac63e5ec3093c84__b)",
  d: "M13.294-19.637a3.273 3.273 0 0 1 2.63 5.296l-.221.253-3.611 3.73 5.982-.102.039 2.314-38.46.654a4.6 4.6 0 0 0-1.725.366 36 36 0 0 0-4.186 2.052l6.229-.106a1.157 1.157 0 0 1 .041 2.314h-.002l-9.256.157-.085-.008a3.5 3.5 0 0 0-1.038 2.342q.058 3.374 7.027 4.51l18.662-.317a4.6 4.6 0 0 1-.168-1.157l-.059-3.469L5.31-.982l4.704 4.547 8.3-.14.04 2.314-5.987.101 8.442 8.159a3.274 3.274 0 0 1-2.219 5.626l-1.542.027a4.64 4.64 0 0 1-2.793-.879L-2.933 6.335l-.289-.229-20.081.342-.411-.031c-5.625-.914-8.905-3.019-8.969-6.753-.059-3.475 3.301-6.209 9.71-8.921a7 7 0 0 1 2.591-.544l18.406-.313 10.965-8.523a4.63 4.63 0 0 1 2.335-.947l.427-.027zM4.39 1.349l-6.942.119.019 1.156c.012.624.274 1.218.729 1.645l.231.192L.611 6.044 15.612 16.9c.407.294.897.448 1.397.44l1.543-.027a.96.96 0 0 0 .65-1.647zm28.352-19.002L27.928-2.337a11.57 11.57 0 0 1-10.843 8.101l-1.049.017-.039-2.316 1.048-.018a9.26 9.26 0 0 0 8.675-6.48l3.852-12.253a8.65 8.65 0 0 0-7.135 3.973L20.43-8.186l-4.633.079-.04-2.314 3.395-.058 1.342-2.078a10.96 10.96 0 0 1 9.039-5.037zM-4.985-5.436l.039 2.314-2.314.039-.039-2.314zm-6.943.118.039 2.314-2.314.039-.039-2.314zm13.886-.236.039 2.314-2.319.039-.039-2.314zM8.9-5.672l.04 2.314-2.314.039-.039-2.314zm6.944-.118.039 2.314-2.314.039-.039-2.314zm6.943-.118.039 2.314-2.314.039-.039-2.314zm-9.454-11.415-1.543.026a2.3 2.3 0 0 0-1.133.32l-.247.168-8.53 6.625 6.94-.118 5.219-5.391a.96.96 0 0 0 .103-1.207l-.126-.148a.96.96 0 0 0-.495-.253z",
  transform: "matrix(1.15 0 0 1.15 43.5 27.5)"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 87 55\" width=\"87\" height=\"55\" style=\"transform:translate3d(0,0,0);content-visibility:visible\">\r\n  <defs>\r\n    <linearGradient id=\"b\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"100%\">\r\n      <stop offset=\"0%\" stop-color=\"var(--theme-primary-grad,#BC32CE)\"/>\r\n      <stop offset=\"100%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n    </linearGradient>\r\n    <clipPath id=\"a\">\r\n      <path d=\"M0 0h87v55H0z\"/>\r\n    </clipPath>\r\n  </defs>\r\n  <g clip-path=\"url(#a)\">\r\n    <path fill=\"url(#b)\" d=\"M13.294-19.637a3.273 3.273 0 0 1 2.63 5.296l-.221.253-3.611 3.73 5.982-.102.039 2.314-38.46.654a4.6 4.6 0 0 0-1.725.366 36 36 0 0 0-4.186 2.052l6.229-.106a1.157 1.157 0 0 1 .041 2.314h-.002l-9.256.157-.085-.008a3.5 3.5 0 0 0-1.038 2.342q.058 3.374 7.027 4.51l18.662-.317a4.6 4.6 0 0 1-.168-1.157l-.059-3.469L5.31-.982l4.704 4.547 8.3-.14.04 2.314-5.987.101 8.442 8.159a3.274 3.274 0 0 1-2.219 5.626l-1.542.027a4.64 4.64 0 0 1-2.793-.879L-2.933 6.335l-.289-.229-20.081.342-.411-.031c-5.625-.914-8.905-3.019-8.969-6.753-.059-3.475 3.301-6.209 9.71-8.921a7 7 0 0 1 2.591-.544l18.406-.313 10.965-8.523a4.63 4.63 0 0 1 2.335-.947l.427-.027zM4.39 1.349l-6.942.119.019 1.156c.012.624.274 1.218.729 1.645l.231.192L.611 6.044 15.612 16.9c.407.294.897.448 1.397.44l1.543-.027a.96.96 0 0 0 .65-1.647zm28.352-19.002L27.928-2.337a11.57 11.57 0 0 1-10.843 8.101l-1.049.017-.039-2.316 1.048-.018a9.26 9.26 0 0 0 8.675-6.48l3.852-12.253a8.65 8.65 0 0 0-7.135 3.973L20.43-8.186l-4.633.079-.04-2.314 3.395-.058 1.342-2.078a10.96 10.96 0 0 1 9.039-5.037zM-4.985-5.436l.039 2.314-2.314.039-.039-2.314zm-6.943.118.039 2.314-2.314.039-.039-2.314zm13.886-.236.039 2.314-2.319.039-.039-2.314zM8.9-5.672l.04 2.314-2.314.039-.039-2.314zm6.944-.118.039 2.314-2.314.039-.039-2.314zm6.943-.118.039 2.314-2.314.039-.039-2.314zm-9.454-11.415-1.543.026a2.3 2.3 0 0 0-1.133.32l-.247.168-8.53 6.625 6.94-.118 5.219-5.391a.96.96 0 0 0 .103-1.207l-.126-.148a.96.96 0 0 0-.495-.253z\" transform=\"matrix(1.15, 0, 0, 1.15, 43.5, 27.5)\" />\r\n  </g>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/plane.7ac63e5ec3093c84babc8045bfe0bf34.svg"),
        {
          React: SvgPlane,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      